import type { JSX } from "react";

import ArrowRight from "@repo/icons/default/ArrowRight";
import { CpsRadioButtonGroup, CpsRadioButtonV2 } from "corpus";

import { Button } from "@/components/ui/button/button";

interface ProceduresTermsSubStepProps {
  defaultValue?: string | null;
  onChange: (value: string) => void;
  onSubmit: () => void | Promise<void>;
  isLoading?: boolean;
  isValid: boolean;
  buttonText?: string;
}

export const ProceduresTermsSubStep = ({
  defaultValue,
  onChange,
  onSubmit,
  isLoading,
  isValid,
  buttonText = "Continuar",
}: ProceduresTermsSubStepProps): JSX.Element => {
  return (
    <div className="flex flex-col gap-6 h-full justify-between pb-6">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <h2 className="text-xl font-bold text-neutral-900">
            Termo de responsabilidade para procedimentos
          </h2>
          <p className="text-sm text-neutral-600">
            De acordo com os requisitos e restrições estabelecidos pela Livance e
            disponíveis{" "}
            <a
              href="https://ajuda.livance.com.br/hc/pt-br/articles/33268318835603-Guia-de-Pr%C3%A1ticas-saiba-o-que-voc%C3%AA-pode-fazer-na-Livance"
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary-500 font-semibold underline"
            >
              nessa página
            </a>
          </p>
        </div>

        <div className="border-l-4 border-secondary-400 bg-neutral-50 rounded-l-lg px-4 py-4 flex flex-col gap-4">
          <p className="text-sm text-neutral-700">
            Declaro que fui claramente informado e estou ciente de todos os requisitos e
            restrições estabelecidas pela Livance para a realização de procedimentos em
            seus consultórios, sejam eles estéticos ou não, disponíveis{" "}
            <a
              href="https://ajuda.livance.com.br/hc/pt-br/articles/33268318835603-Guia-de-Pr%C3%A1ticas-saiba-o-que-voc%C3%AA-pode-fazer-na-Livance"
              target="_blank"
              rel="noreferrer"
              className="text-secondary-400 font-semibold underline"
            >
              aqui
            </a>
            , aderindo plenamente a essas regras.
          </p>
          <p className="text-sm text-neutral-700">
            Preencho todos os requisitos exigidos pelo meu Conselho Profissional para a
            realização de procedimentos, me comprometendo a realizar somente os
            procedimentos por ele autorizados e nos limites estabelecidos pela Livance.
          </p>
          <p className="text-sm font-semibold text-neutral-700">
            O descumprimento destas declarações poderá implicar rescisão contratual e
            eventual responsabilização nas esferas ética, civil, administrativa e
            criminal.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-base font-semibold text-neutral-900">
            Selecione a sua declaração
          </p>
          <CpsRadioButtonGroup
            defaultValue={defaultValue ?? undefined}
            onChange={(value) => {
              if (typeof value === "string") onChange(value);
            }}
          >
            <CpsRadioButtonV2 id="no-aesthetic" value="nao" label="">
              <span className="font-medium">
                Estou de acordo e{" "}
                <span className="text-primary-500 font-semibold">não irei</span> realizar
                procedimentos estéticos
              </span>
            </CpsRadioButtonV2>
            <CpsRadioButtonV2 id="yes-aesthetic" value="sim" label="">
              <span className="font-medium">
                Estou de acordo e{" "}
                <span className="text-primary-500 font-semibold">irei</span> realizar
                procedimentos estéticos
              </span>
            </CpsRadioButtonV2>
          </CpsRadioButtonGroup>
        </div>
      </div>

      <div className="flex sticky bottom-0 self-end bg-white w-full">
        <Button
          loading={isLoading}
          fullWidth
          onClick={() => {
            void onSubmit();
          }}
          disabled={!isValid}
        >
          <div className="flex flex-row gap-2 items-center">
            {buttonText}
            <ArrowRight size={24} />
          </div>
        </Button>
      </div>
    </div>
  );
};
